<template>
    <el-dialog :visible.sync="visible" title="Агентства" :append-to-body="true" width="600px" v-loading="isLoading">
        <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="agency in agencies" :key="agency.id">
                <AgencyManageListItem :agency="agency" @updated="handlerUpdated" />
            </li>
            <li class="list-group-item">
                <span class="text-muted mt-2">Добавить агенство</span>
                <form class="form-inline justify-content-between mt-2">
                    <input class="form-control" type="text" v-model="creating.name" placeholder="Название">
                    <button @click.prevent="create(creating)" class="btn btn-primary">Добавить</button>
                </form>
            </li>
        </ul>
    </el-dialog>
</template>

<script>
import AgencyManageListItem from "./AgencyManageListItem.vue";

export default {
    name: "AgenciesManage",
    components: {AgencyManageListItem},
    data: () => ({
        visible: false,
        isLoading: false,
        agencies: [],
        errors: {},

        creating: {name: ""},
    }),
    mounted() {
        let self = this;
        this.$bus.$on('agencies:open-manage', () => {
            self.visible = true;
        })
    },
    watch: {
        visible(v) {
            if (v) this.fetch();
        }
    },
    methods: {
        handlerUpdated() {
            this.fetch(false);
        },
        fetch(withLoader) {
            let self = this;
            if (withLoader) self.isLoading = true;
            axios.get('/api/agencies')
                .then(res => {
                    self.agencies = res.data;
                    self.isLoading = false;
                })
        },
        create(c) {
            let self = this;
            self.isLoading = true;
            axios.post('/api/agencies/', c)
                .then(res => {
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Добавлено',
                        duration: 2000,
                    });
                    self.creating = {name: ""}
                    self.fetch();
                })
                .catch(e => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка!',
                        duration: 2000,
                    });
                })
        }
    }
}
</script>

<style scoped>

</style>
